'use client';
import { useEffect } from 'react';

export default function CursorAndProgress() {
  useEffect(() => {
    const dot = document.getElementById('cursor-dot');
    const ring = document.getElementById('cursor-ring');
    const progress = document.getElementById('scroll-progress');

    if (!dot || !ring) return;

    let ringX = 0, ringY = 0;
    let mouseX = 0, mouseY = 0;
    let rafId: number;

    const onMove = (e: MouseEvent) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      dot.style.left = mouseX + 'px';
      dot.style.top = mouseY + 'px';
    };

    const animateRing = () => {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      ring.style.left = ringX + 'px';
      ring.style.top = ringY + 'px';
      rafId = requestAnimationFrame(animateRing);
    };
    animateRing();

    const onScroll = () => {
      if (!progress) return;
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? scrollTop / docHeight : 0;
      progress.style.transform = `scaleX(${pct})`;
    };

    const onEnter = () => document.body.classList.add('cursor-hover');
    const onLeave = () => document.body.classList.remove('cursor-hover');

    window.addEventListener('mousemove', onMove, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });

    const interactives = document.querySelectorAll('a, button, .card-hover, .diff-card, .program-card, .testimonial-card');
    interactives.forEach(el => {
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mouseleave', onLeave);
    });

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <>
      <div data-component-id="src/app/mps-early-years/components/CursorAndProgress.tsx:61:6" data-component-path="src/app/mps-early-years/components/CursorAndProgress.tsx" data-component-line="61" data-component-end-line="61" data-component-file="CursorAndProgress.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22scroll-progress%22%7D" id="scroll-progress" />
      <div data-component-id="src/app/mps-early-years/components/CursorAndProgress.tsx:62:6" data-component-path="src/app/mps-early-years/components/CursorAndProgress.tsx" data-component-line="62" data-component-end-line="62" data-component-file="CursorAndProgress.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22cursor-dot%22%7D" id="cursor-dot" />
      <div data-component-id="src/app/mps-early-years/components/CursorAndProgress.tsx:63:6" data-component-path="src/app/mps-early-years/components/CursorAndProgress.tsx" data-component-line="63" data-component-end-line="63" data-component-file="CursorAndProgress.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22cursor-ring%22%7D" id="cursor-ring" />
    </>
  );
}